import { createApp } from 'vue'
import App from './App.vue';
import router from './router';
import store from './store'; // Import Vuex store
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css';

// createApp(App).mount('#app')
const vuetify = createVuetify({
    components,
    directives,
  })

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app');